import styled from "styled-components";
import { StyledButton } from "../../Components/StyledComponents/StyledComponents";

export const StartedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 1366px;
  flex: 1;
  overflow: hidden;
  height: 100vh;
`;

export const ImageWrapper = styled.div`
  width: 50%;
  height: 100vh;
  background: #f5f7fa;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const SecondWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 22.5vh;
  margin-left: 115px;
  padding-right: 96px;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 34px;
  line-height: 150%;
  letter-spacing: -0.138889px;
  color: #09274a;
  margin: 0;
  padding: 0;
  font-family: "Inter";
`;

export const LogoWrapper = styled.div`
  width: 124px;
  height: 42.18px;
  margin-bottom: 20px;
`;

export const LogoImage = styled.img`
  width: 124px;
  height: 42.18px;
  margin-bottom: 20px;
`;

export const Label = styled.label`
    width: ${(props) => (props.width ? props.width : "100%")};
    line-height: 20px;
    font-weight: 500;
    font-size: 13px;
    color: #28476a;
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
    font-family: "Inter";
`;

export const LoginButton = styled.button`
  position: relative;
  font-family: "Poppins";
  display: "flex";
  width: ${(props) => (props.$otherProvider ? "fit-content" : "80px")};
  height: 40px;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  padding: 6px 16px;
  margin-top: ${(props) => (props.$otherProvider ? "0" : "24px")};
  border-radius: 4px;
  outline: none !important;
  cursor: pointer;
  letter-spacing: 0.232143px;
  background-color: rgba(20, 115, 230, 1);
  border: 1px solid white;
  color: rgba(255, 255, 255, 1);

  &:hover {
    background-color: rgba(64, 146, 245, 1);
  }

  &.disabled {
    color: rgb(151, 163, 183);
    background-color: rgba(237, 239, 245, 1);
    pointer-events: none;
  }
`;

export const StyledInput = styled.input`
  width: 308px;
  height: 36px;
  margin-bottom: 24px;
  border: 1px solid #d6dde8;
  border-radius: 4px;
  padding: 8px 8px 8px 10px;
  box-sizing: border-box;
  &::placeholder {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    font-family: Inter, sans-serif;
    letter-spacing: 0.25px;
  }
  &.error,
  &:focus.error {
    border: 1px solid #CD3746;
    outline: none;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: ${(props) => (props.$otherProvider ? "0" : "8px")};
  margin-bottom: ${(props) => (props.$otherProvider ? "8px" : "0")};
  color: #cd3746;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-align: left;
`;

export const FlexBox = styled.div`
  display: flex;
  margin-top: ${(props) => (props.$otherProvider ? "-8px" : "0")};
  margin-bottom: ${(props) => (props.$otherProvider ? "8px" : "0")};
`;

export const EmailSelectorWrapper = styled(StyledButton)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  border-radius: 6px;
  border-width: 1px;
  padding: 16px;
  border: 1px solid #506DFF;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const EmailSelectorInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  vertical-align: middle;
  color: #343C45;
  width: 121px;
`;

export const SelectLoginButtonTextWrapper = styled(Label)`
  font-family: Inter;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #28476A;
  margin-bottom: 0px;
`;

export const EmailProviderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 88px;
  gap: 12px;
  margin-bottom: 20px;
`;

export const EmailProviderOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 56px;
  gap: 12px;
`;

export const EmailLabelText = styled(Label)`
  font-family: Inter;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #28476A;
  margin-bottom: 12px;
`;

export const ProductSelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

export const ProductOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #28476A;
`;

export const RadioInput = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #4285F4;
`;

export const OtpScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 320px;
  margin-bottom: 22.5vh;
`;

export const HelpLinkButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  font-size: 13px;
  color: #506dff;
  cursor: pointer;
  padding: 0;
  margin-bottom: 16px;
  &:hover {
    text-decoration: underline;
  }
`;

export const OtherPasswordScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`; 

export const StyledTooltip = styled.img`
  display: flex;
  align-items: center;
  margin: 8px 8px 0 0;
  margin: ${(props) => (props.$otherProvider ? "2px 8px 0 0" : "8px 8px 0 0")};
`;

// ── New Wizard Login Styles ──

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`;

export const ImagePanel = styled.div`
  width: 50%;
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const RightPanel = styled.div`
  width: 50%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 497px;
  max-width: 497px;
`;

export const WizardTitle = styled.h1`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #0f172a;
  margin: 0;
  padding: 0;
`;

export const WizardSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #475569;
  margin: 0;
  padding: 0;
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ExternalTitle = styled.h1`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
  margin: 0;
  padding: 0;
`;

export const ExternalSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: #475569;
  margin: 0;
  padding: 0;
`;

export const ExternalLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #1e40af;
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    color: #94a3b8;
    text-decoration: none;
    cursor: default;
  }
`;

export const ExternalErrorMessage = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #d52c1f;
`;

export const InputLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
`;

export const WizardInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
  outline: none;
  transition: border-color 0.15s ease;
  &::placeholder { color: #475569; }
  &:focus { border-color: #196fe0; }
  &:read-only { background-color: #f5f7fa; cursor: default; }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: none;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  background-color: ${(props) => (props.disabled ? '#edf1f6' : '#196fe0')};
  color: ${(props) => (props.disabled ? '#94a3b8' : '#ffffff')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover:not(:disabled) { background-color: #1560c4; }
`;

export const WizardErrorMessage = styled.div`
  color: #cd3746;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;
`;

export const BackHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BackArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export const EmailPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f7f7f7;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: #0f172a;
`;

export const EmailDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #94a3b8;
  flex-shrink: 0;
`;

export const WizardLogoWrapper = styled.div`
  width: 121px;
  height: 41px;
  /* the svg artwork starts 2.67px into its canvas (shadow bleed room),
     pull it back so the visible edge lines up with the headings */
  & img { width: 100%; height: 100%; object-fit: contain; margin-left: -12px; }
`;

export const ProductCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  border: ${(props) => (props.$isSelected ? '2px solid #196fe0' : '1px solid #e5e5e5')};
  background: ${(props) => (props.$isSelected ? '#f6f8fc' : '#ffffff')};
  box-sizing: border-box;
  width: 100%;
  &:hover { border-color: ${(props) => (props.$isSelected ? '#196fe0' : '#cbd5e1')}; }
`;

export const OAuthButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
  transition: background-color 0.15s ease;
  &:hover { background-color: #f8fafc; }
`;

export const OrDividerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const OrDividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: #e2e8f0;
`;

export const OrDividerText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #64748b;
`;
